import { render, staticRenderFns } from "./single-select.vue?vue&type=template&id=0ed4f4e2"
import script from "./single-select.vue?vue&type=script&lang=js"
export * from "./single-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports